import { formatJpy } from "@tcg/ui";

/**
 * `¥19,000` in every staff language (T07-22 MoneyText): `Intl` writes the full-width `￥` for
 * `ja-JP` — the register (and its printed receipts) use the half-width `¥`. Display only: the
 * amount is the server's integer as is.
 */
export function formatYen(amount: number, locale = "ja"): string {
  return formatJpy(amount, locale).replace(/￥/g, "¥");
}
